import { mapState } from 'vuex';
import GLOBAL_FILTER_BUS, { EVENTS } from '../../modules/global-filters/bus';

export default {
  name: 'WorkWithDashboardFilterMixin',
  data() {
    return {
      fetchNeeded: false,
      componentIsActive: true
    };
  },
  computed: {
    ...mapState(['GlobalFilters'])
  },
  activated() {
    this.componentIsActive = true;
    if (this.fetchNeeded) {
      if (this.infoPathParam) {
        this.fetchData(this.infoPathParam);
      } else {
        this.fetchData();
      }
      this.fetchNeeded = false;
    }
  },
  deactivated() {
    this.componentIsActive = false;
  },
  beforeDestroy() {
    GLOBAL_FILTER_BUS.$off(EVENTS.FORM_SUBMIT, this.handleBus);
  },
  mounted() {
    GLOBAL_FILTER_BUS.$on(EVENTS.FORM_SUBMIT, this.handleBus);
  },
  methods: {
    handleBus() {
      if (this.componentIsActive) {
        if (this.infoPathParam) {
          this.fetchData(this.infoPathParam);
        } else {
          this.fetchData();
        }
      } else {
        this.fetchNeeded = true;
      }
    }
  }
};
